import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useBranding } from '../Context/BrandingContext';
import { hasAnsweredCookieConsent, setCookieConsent } from '../utils/cookieConsent';

export default function CookieConsent() {
  const { branding } = useBranding();
  const [visible, setVisible] = useState(false);

  const sync = useCallback(() => {
    setVisible(!hasAnsweredCookieConsent());
  }, []);

  useEffect(() => {
    sync();
    const onChange = () => sync();
    window.addEventListener('avs-cookie-consent-changed', onChange);
    return () => window.removeEventListener('avs-cookie-consent-changed', onChange);
  }, [sync]);

  if (!visible) return null;

  const acceptAll = () => {
    setCookieConsent('all');
    setVisible(false);
  };

  const essentialOnly = () => {
    setCookieConsent('essential');
    setVisible(false);
  };

  return (
    <div
      role="dialog"
      aria-label={`Cookie consent — ${branding.companyName}`}
      style={styles.bar}
    >
      <div style={styles.inner}>
        <p style={styles.text}>
          {`We use cookies and similar technologies to operate the ${branding.companyName} customer portal (for example to keep you signed in)`}
          {' '}
          and, if you allow it, to understand usage and improve the product. See our{' '}
          <Link to="/privacy" style={styles.link}>
            Privacy Policy
          </Link>{' '}
          for details. You can accept all cookies or only essential ones required for the service to work.
        </p>
        <div style={styles.actions}>
          <button type="button" onClick={essentialOnly} style={styles.btnSecondary}>
            Essential only
          </button>
          <button
            type="button"
            onClick={acceptAll}
            style={{ ...styles.btnPrimary, backgroundColor: branding.primaryColor }}
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  bar: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
    padding: '16px',
    backgroundColor: 'rgba(17, 24, 39, 0.96)',
    color: '#f3f4f6',
    boxShadow: '0 -4px 24px rgba(0, 0, 0, 0.15)',
  },
  inner: {
    maxWidth: '960px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  text: {
    margin: 0,
    fontSize: '14px',
    lineHeight: 1.55,
    color: '#e5e7eb',
  },
  link: {
    color: '#93c5fd',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    justifyContent: 'flex-end',
  },
  btnSecondary: {
    padding: '10px 18px',
    borderRadius: '10px',
    border: '1px solid #6b7280',
    backgroundColor: 'transparent',
    color: '#f9fafb',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  btnPrimary: {
    padding: '10px 18px',
    borderRadius: '10px',
    border: 'none',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};
